import * as R from 'ramda'

export const renameKey = R.curry(
  (oldName, newName, obj) => R.pipe(
    R.assoc(newName, obj[oldName]),
    R.dissoc(oldName)
  )(obj)
)

export const transformKeys = R.curry(
  (transform, obj) => R.reduce(
    (acc, key) => ({
      ...acc,
      [transform(key)]: obj[key]
    }),
    {},
    R.keys(obj)
  )
)
